import React from 'react';
import { string, number } from 'prop-types';
import styled from 'styled-components';

const AvatarContainer = styled('div')(({ size }) => ({
  width: size,
  height: size,
  margin: 'auto',
  borderRadius: size / 2,
  overflow: 'hidden',
  objectFit: 'contain'
}));

const Avatar = ({ link, size }) => (
  <AvatarContainer size={size}>
    <img width={`${size}px`} height={`${size}px`} alt="avatar" src={link} loading="lazy" />
  </AvatarContainer>
);

Avatar.defaultProps = {
  size: 24
};

Avatar.propTypes = {
  link: string,
  size: number.isRequired
};

export default Avatar;
